import {BASE_URL} from "../../../config/config";

export const getAbsoluteUrl = (path: string = ''): string => {
    const baseUrl = BASE_URL || `${window.location.protocol}//${window.location.host}/`

    return `${baseUrl}${path}`;
}
